import { render, staticRenderFns } from "./PlaceAutocomplete.vue?vue&type=template&id=1c00f4d7&"
import script from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../var/www/transport-app/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports